"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var listSize = {
  s: '10%',
  m: '20%',
  l: '30%'
};
var Cell = _styledComponents.default.div.withConfig({
  displayName: "ListCell__Cell",
  componentId: "sc-1rty8bs-0"
})(["overflow:hidden;", ""], function (_ref) {
  var fixed = _ref.fixed,
    size = _ref.size;
  return fixed ? (0, _styledComponents.css)(["flex:0 0 ", ";"], fixed) : size ? (0, _styledComponents.css)(["width:", ";flex-shrink:0;"], listSize[size]) : (0, _styledComponents.css)(["width:auto;flex:1;"]);
});
var ListCell = function ListCell(_ref2) {
  var children = _ref2.children,
    fixed = _ref2.fixed,
    size = _ref2.size,
    onClick = _ref2.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Cell, {
    fixed: fixed,
    size: size,
    onClick: onClick,
    children: children
  });
};
ListCell.defaultProps = {};
var _default = exports.default = ListCell;